export default {
  WORKSITE: 1,
  EMPLOYEE: 2,
  VEHICLE: 3,
};
